import React, { ChangeEvent } from 'react';
import { DescontoCategoria } from '../../../../services/descontoTorneioService';

type Props = {
  value: DescontoCategoria;
  onChange: (patch: Partial<DescontoCategoria>) => void;
  onDelete?: () => void;
  busy?: boolean;
};

const TournamentDiscountItem: React.FC<Props> = ({
  value,
  onChange,
  onDelete,
  busy = false,
}) => {
  const handleField = (field: keyof DescontoCategoria) => (
    e: ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const val = field === 'valor' || field === 'ordem' ? Number(e.target.value) : e.target.value;
    onChange({ [field]: val } as Partial<DescontoCategoria>);
  };

  return (
    <div className={`card p-3 position-relative ${busy ? 'opacity-75' : ''}`} aria-busy={busy}>
      {busy && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 d-flex align-items-center justify-content-center rounded">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <div className="d-flex align-items-center gap-3">
        <div style={{ width: 120 }}>
          <strong>{value.ordem}ª Categoria</strong>
        </div>
        <div className="flex-grow-1">
          <label className="form-label">Tipo</label>
          <select
            className="form-select"
            value={value.tipo}
            onChange={handleField('tipo')}
            disabled={busy}
          >
            <option value="PERCENTUAL">PERCENTUAL</option>
            <option value="FIXO">FIXO</option>
          </select>
        </div>
        <div className="flex-grow-1">
          <label className="form-label">Valor</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={value.valor}
            onChange={handleField('valor')}
            disabled={busy}
          />
        </div>
        {onDelete && (
          <button
            type="button"
            className="btn btn-link text-danger"
            onClick={onDelete}
            disabled={busy}
            aria-label="Remover desconto"
            title="Remover desconto"
          >
            <i className="bi bi-trash fs-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TournamentDiscountItem;

